export default __webpack_public_path__ + "static/rfc-first-gamers-homepage-banner-642c9d596719ec5288ab40a7286b4c8d.webp";